//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { layoutStore, pageStore } from '@/store';
import Breadcrumbs from '@/components/Breadcrumbs.vue';
import getImage from '@/helpers/getImage';
import PageService from '~/services/Page';
import ContentBlocks from '@/components/Content/ContentBlocks';
import { buildPageHead, buildPageHeadMetaInfo } from '@/helpers/buildPageHead';
import BannerService from '@/services/Banner';
import { BANNER_PLACES } from '@/constants/banners';
import AdBannerController from '@/components/AdBannerController';
import UserCard from '@/components/UserCard';
import { normalizeBase } from '@/helpers/normalizeContentBlocks';
import UsefulInformation from '~/components/UsefulInformation.vue';
import makeClasses from '~/helpers/makeClasses';
import formatDate from '~/helpers/formatDate';
import PageMetaInfo from '~/components/PageMetaInfo.vue';
import PageSocialBlock from '~/components/PageSocialBlock.vue';

const VIEWS = {
    vertical: 'vertical',
    horizontal: 'horizontal'
};

const THEMES = {
    white: 'white',
    outline_light_gray: 'outline_light_gray',
    global: 'global'
};

const useClasses = makeClasses(() => ({
    reviewsButton: ({ view, disableReview }) => ({
        'transition-fast relative': true,
        'hover:opacity-60': !disableReview,
        'pointer-events-none': disableReview,
        'mb-3': view === VIEWS.vertical
    }),
    reviewsContainer: () => 'flex items-center -mx-0.5 whitespace-nowrap',
    star: () => ({
        'mx-0.5 fill-current': true
    })
}));

export default {
    name: 'Article',
    components: {
        PageSocialBlock,
        PageMetaInfo,
        UsefulInformation,
        Breadcrumbs,
        ContentBlocks,
        AdBannerController,
        UserCard
    },
    async asyncData({ error, route }) {
        let data = {
            page: null
        };

        try {
            const page = await PageService.fetchData(route.path);

            data.page = page;

            if (page) {
                pageStore.update(page);
            }

            if (page?.content && page.content.id) {
                data.page.content = await PageService.fetchContent(page.content.id);
            } else {
                data.page.content = page.content;
            }
        } catch (_error) {
            pageStore.reset();
            error({ statusCode: 404 });
        } finally {
            if (process.server) {
                pageStore.fix();
            }
        }

        try {
            let routePath = !route.path.endsWith('/') ? route.path + '/' : route.path;
            routePath = !routePath.startsWith('/') ? '/' + routePath : routePath;

            const banner = await BannerService.fetchBanners(
                {
                    page: 1,
                    limit: 2,
                    exactLink: routePath
                },
                {
                    progress: false
                }
            );

            if (banner.items && banner.items.length) {
                data.rightBanner = banner.items.find(b => b.place === BANNER_PLACES.TYPICAL_PAGE_RIGHT);
                data.contentBanner = banner.items.find(b => b.place === BANNER_PLACES.TYPICAL_PAGE_CONTENT);
            } else {
                data.rightBanner = null;
                data.contentBanner = null;
            }
        } catch (e) {
            console.log('Can not fetch banner');
            data.rightBanner = null;
            data.contentBanner = null;
        }

        return data;
    },
    data() {
        return {
            page: null
        };
    },
    head() {
        return buildPageHead({
            metaInfo: buildPageHeadMetaInfo(this.page, pageStore.pageHost),
            metaTitle: this.title
        });
    },
    computed: {
        classes() {
            return useClasses({
                view: VIEWS.vertical,
                theme: THEMES.white,
                activeRating: 5,
                disableReview: true
            });
        },
        connectedPagesRight() {
            return this.page?.connectedPages?.filter(p => p?.posRight);
        },
        connectedPagesBottom() {
            return this.page?.connectedPages?.filter(p => p?.posBottom);
        },
        title() {
            return this.page?.title || this.page?.meta?.title || 'Статья';
        },
        subtitle() {
            return this.page?.subtitle || 'Подзаголовок';
        },
        seoContent() {
            return {
                title: this.page?.seoTitle || '',
                tag: this.page?.seoTag || '',
                description: this.page?.seoContent || ''
            };
        },
        normalizedBlocks() {
            const blocks = this.page?.content?.blocks;
            if (!blocks) {
                return [];
            }

            return blocks
                .map(item => {
                    return this.normalizeBase(item);
                })
                .filter(x => x);
        },
        bannersFilter() {
            return {
                limit: 1
            };
        },
        breadcrumbs() {
            return [
                {
                    title: 'Главная',
                    name: 'index'
                },
                {
                    title: 'Статьи',
                    path: '/articles'
                },
                {
                    title: this.title,
                    path: null
                }
            ];
        }
    },
    mounted() {
        layoutStore.updateHeaderTheme('white');
    },
    destroyed() {
        if (this.$route.name !== 'all') {
            layoutStore.updateHeaderTheme('transparent');
        }
    },
    methods: {
        getBottomImage(url) {
            return getImage(url, 'rs:fit:314:157');
        },
        onPageChange(payload) {
            if (!payload?.page) return;
            this.page = payload.page;
        },
        normalizeBase,
        optimizedImageUrl(imageUrl) {
            return getImage(imageUrl, 'rs:fit:293:485');
        }
    }
};
